import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

import boTheme from '@ecp/common/src/style/theme/bo';
import { FlexBoxSpaceBetween } from '@ecp/common/src/layouts/flex/styled';
import { ReactComponent as TooltipCloseIcon } from '@ecp/common/src/assets/icon/icon__bo__close.svg';

const FADE_OUT = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
const FADE_IN = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const StyledToast = styled(FlexBoxSpaceBetween)`
  position: relative;
  width: 450px;
  height: 42px;
  margin-top: 10px;
  padding: 13px 20px;
  color: ${boTheme.color.sub10};
  font-size: ${boTheme.font.size.small};
  font-weight: ${boTheme.font.weight.regular};
  line-height: 100%;
  background-color: ${boTheme.color.menu1};
  border-radius: 3px;
  box-shadow: 2px 2px 6px rgba(76, 75, 100, 0.2);
  animation: 0.3s forwards ${({ isClosing }) => (isClosing ? FADE_OUT : FADE_IN)};
`;

const StyledClose = styled(TooltipCloseIcon)`
  cursor: pointer;
`;

const Toast = (props) => {
  const { content, duration } = props;
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const setExistTimeout = setTimeout(() => {
      setIsClosing(true);
      clearTimeout(setExistTimeout);
    }, 300 + (duration ?? 1700));
  });

  const handleClose = () => {
    setIsClosing(true);
  };

  return (
    <StyledToast isClosing={isClosing}>
      {content}
      <StyledClose onClick={handleClose} />
    </StyledToast>
  );
};

Toast.propTypes = {
  content: PropTypes.string,
  duration: PropTypes.number,
};
export default Toast;
